import Rails from "@rails/ujs";
import axios from "axios";
import React, { useState } from "react";
import toastr from "toastr";

interface TruckRemarks {
  remarks: string;
  id: number;
}

interface TruckRemarksProps {
  remarks: string;
  id: number;
}

const TruckRemarks = (props: TruckRemarksProps) => {
  const [edited, setEdited] = useState(false),
    [remarks, setRemarks] = useState(props.remarks),
    patchTruckRemarks = () => {
      axios
        .patch(`/trucks/${props.id}.json`, {remarks}, {
          headers: {
            "X-CSRF-Token": Rails.csrfToken(),
            "Content-Type": "application/json",
          },
        })
        .then(() => {
          toastr.success("New truck info saved", "Success");
          setEdited(false);
        });
    },
    revertChanges = () => {
      setRemarks(props.remarks);
      setEdited(false);
    };

  return edited ? (
    <div className="ibox-content">
      <div className="float-right mb-2">
        <button className="btn p-0 mr-4" onClick={() => revertChanges()}>
          <i className="fa fa-undo" aria-hidden="true"></i>
        </button>
        <button className="btn p-0 mr-4" onClick={() => patchTruckRemarks()}>
          <i className="fa fa-floppy-o" aria-hidden="true"></i>
        </button>
      </div>
      <div className="form-group row">
        <label className="col-lg-1 col-md-2 col-sm-4 text-sm-left">
          <dt>Remarks:</dt>
        </label>
        <div className="col-lg-6 col-md-8 col-sm-8">
          <textarea
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            className="form-control"
            name="remarks"
            id="truck_remarks"
          />
        </div>
      </div>
    </div>
  ) : (
    <div className="ibox-content">
      <div className="float-right mb-2">
        <button className="btn p-0" onClick={() => setEdited(true)}>
          <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
        </button>
      </div>
      <div className="form-group row">
        <label className="col-lg-1 col-md-2 col-sm-4 text-sm-left">
          <dt>Remarks:</dt>
        </label>
        <div className="col-lg-6 col-md-8 col-sm-8">{remarks}</div>
      </div>
    </div>
  );
};
export default TruckRemarks;
